import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Label, List } from 'semantic-ui-react';

import './AuthLabel.css';
import * as config from '../config';
import AuthContext from '../context/AuthContext';

// Selector for the icon in the org portion of the AuthLabel
const ORG_ICON = {
  salesforce: 'cloud',
  dynamics: 'microsoft',
  storybook: 'book',
};

/**
 * Label which displays info about the current user and org
 *
 * This label uses AuthContext to provide the username and org name.
 *
 * TODO This component is currently not rendered for dynamics
 */
class AuthLabel extends React.Component {
  static contextType = AuthContext;

  render() {
    const { embed } = this.props;
    // TODO allow dynamics to render after required data is retrieved
    if (embed === 'dynamics') { return null; }

    const { user, org } = this.context;
    return (
      <List className="ds__AuthLabel">
        <List.Item>
          <Label color="blue">
            <Icon name="user" /> {user.name}
          </Label>
        </List.Item>
        <List.Item>
          <Label>
            <Icon name={ORG_ICON[embed]} /> {org.name}
          </Label>
        </List.Item>
      </List>
    );
  }
}

export default AuthLabel;

AuthLabel.propTypes = {
  embed: PropTypes.oneOf(['salesforce', 'dynamics']),
};

AuthLabel.defaultProps = {
  embed: config.EMBED,
};
